import React, { useState, useEffect } from 'react';
import Alert from './Alert';
import { Link } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { getUserInfo } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import { environment } from './functions/environment';

function TechnicianMaster() {
    let [sessOut, setSessOut] = useState(false);
    let [alert, setAlert] = useState({
        msg: "",
        status: false
    });
    let userObj = getUserInfo();
    let [technicianData, settechnicianData] = useState({
        area: "",
        branch: "",
        userName: ""
    });
    let [istechnique, setistechnique] = useState(false)

    useEffect(() => {
        getArea();
        getPersona();
    }, [])

    let [area, setarea] = useState([]);

    function getArea() {
        setistechnique(false);
        fetch(environment.baseUrl + 'getAllAreas', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        }).then((res) => {
            res.json().then((resp) => {

                if (resp.code == 200) {
                    setarea(resp.data.result);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setarea([]);
                }

            })
        })
    }

    let [branch, setBranch] = useState([]);
    let [branch1, setBranch1] = useState([]);
    function getBranch(id) {
        setBranch([]);
        setUser([]);
        setistechnique(false);
        fetch(environment.baseUrl + 'getBranchByArea', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                "areaID": id
            })
        }).then((res) => {
            res.json().then((resp) => {
                if (resp.code == 200) {
                    setBranch(resp.data.result);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setBranch([]);
                }

            })
        })
    }
    function getBranch1(id) {
        fetch(environment.baseUrl + 'getBranchByArea', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                "areaID": id
            })
        }).then((res) => {
            res.json().then((resp) => {
                if (resp.code == 200) {
                    setBranch1(resp.data.result);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setBranch1([]);
                }
            })
        })
    }

    let [user, setUser] = useState([]);
    function getUser(did) {
        fetch(environment.baseUrl + 'getTechnicianUserByBranch', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                branchID: did,
                areaID: areaID
            })
        }).then((res) => {
            res.json().then((resp) => {
                if (resp.code == 200) {
                    setUser(resp.data.result);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setUser([]);
                }
            })
        })
    }
    let [technicianOnboard, settechnicianOnboard] = useState([]);
    let [technicianUser, setTechnicianUser] = useState({
        businessFunction: "",
        Area: "",
        Branch: "",
        firstName: "",
        lastName: "",
        emailID: "",
        Mobile_Number: "",
        areaID: "",
        branchID: "",
        personaID: ""

    });
    function getTechnicianUser(ddid) {
        fetch(environment.baseUrl + 'getTechnicianUserByID', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                "userID": ddid
            })
        }).then((res) => {
            res.json().then((resp) => {
                if (resp.code == 200) {
                    setTechnicianUser(resp.data.result[0]);
                    getBranch1(resp.data.result[0].areaID);
                    // if (technicianUser !== {}) {
                    setistechnique(true);
                    // }
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setTechnicianUser([]);
                }

            })
        })
    }
    function updateUser() {
        fetch(environment.baseUrl + "updateUser", {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                userID: technicianUser.userID,
                areaID: technicianUser.areaID,
                branchID: technicianUser.branchID,
                firstName: technicianUser.firstName,
                lastName: technicianUser.lastName,
                personaID: technicianUser.personaID,
                phoneNumber: technicianUser.Mobile_Number ? technicianUser.Mobile_Number : "NA",
                isActive: technicianUser.isActive
            })
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                if (resp.code == 200) {
                    setistechnique(false);
                    setBranch([]);
                    setUser([]);
                    setareaID("");
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                setAlert({
                    msg: resp.msg,
                    status: true
                });
            })
        })

    }
    function technicianUserOnboard() {
        fetch(environment.baseUrl + "technicianUserOnboard", {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                emailID: technicianUser.emailID,
                isActive: technicianUser.isActive,
                phoneNumber: technicianUser.Mobile_Number ? technicianUser.Mobile_Number : "",
            })
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                setAlert({
                    msg: resp.msg,
                    status: true
                });
                if (resp.code == 200) {
                    getArea();
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
            })
        })

    }
    let [persona, setPersona] = useState([]);
    function getPersona() {
        fetch(environment.baseUrl + 'getPersona', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        }).then((res) => {
            res.json().then((resp) => {
                if (resp.code == 200) {
                    setPersona(resp.data.result);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setPersona([]);
                }
            })
        })
    }
    let [areaID, setareaID] = useState("")
    function getData(e) {
        if (e.target.name == "area") {
            setareaID(e.target.value)
            getBranch(e.target.value);
        }
        if (e.target.name == "branch") {
            setistechnique(false);
            getUser(e.target.value);
        }
        if (e.target.name == "userName") {
            setTechnicianUser({
                businessFunction: "",
                Area: "",
                Branch: "",
                firstName: "",
                lastName: "",
                emailID: "",
                Mobile_Number: "",
                areaID: "",
                branchID: "",
                personaID: ""
            })
            getTechnicianUser(e.target.value);
        }
        settechnicianData({ ...technicianData, [e.target.name]: e.target.value });
    }

    function getTechnicianMasterData(e) {
        if (e.target.name == "areaID" || e.target.name == "branchID" || e.target.name == "personaID") {
            setTechnicianUser({ ...technicianUser, [e.target.name]: e.target.value == "" ? "" : parseInt(e.target.value) });
            if (e.target.name == "areaID" && e.target.value != "") {
                setTechnicianUser({ ...technicianUser, [e.target.name]: e.target.value == "" ? "" : parseInt(e.target.value) });
                setBranch1([]);
                getBranch1(e.target.value);
            }
        }
        else {
            setTechnicianUser({ ...technicianUser, [e.target.name]: e.target.value });
        }
    }
    let [errorMsg, setErrorMsg] = useState({});
    function validate() {
        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const phoneRegex = /^[0]?[6789]\d{9}$/;
        let errror = {};
        if (technicianUser.areaID == "") {
            errror.areaID = "This field is required";
        }
        if (technicianUser.branchID == "") {
            errror.branchID = "This field is required";
        }
        if (technicianUser.personaID == "") {
            errror.personaID = "This field is required";
        }
        if (technicianUser.firstName == "") {
            errror.firstName = "This field is required";//Select Acoount"
        }
        if (technicianUser.firstName.length > 25) {
            errror.firstName = "Exceeded 25 characters limit";//Select Acoount"
        }

        if (technicianUser.lastName == "") {
            errror.lastName = "This field is required";//Select Acoount"
        }
        if (technicianUser.lastName.length > 25) {
            errror.lastName = "Exceeded 25 characters limit";//Select Acoount"
        }

        if (technicianUser.Mobile_Number) {
            if (isNaN(technicianUser.Mobile_Number)) {
                errror.Mobile_Number = "Mobile number must be in digit";
            }
            else if (technicianUser.Mobile_Number.length > 10 || technicianUser.Mobile_Number != "" && technicianUser.Mobile_Number.length < 10) {
                errror.Mobile_Number = "Enter mobile number must be 10 digits";//Select Acoount"
            }
            else if (!technicianUser.Mobile_Number.match(phoneRegex)) {
                errror.Mobile_Number = "Enter valid mobile number";
            }
        }


        if (technicianUser.emailID == "") {
            errror.emailID = "This field is required";//Select Acoount"
        }

        else if (technicianUser.emailID.match(emailRegex)) {
        }
        else {
            errror.emailID = "Enter valid email format";
        }


        setErrorMsg(errror);
        if (Object.keys(errror).length == 0) {
            updateUser();

        }
    }
    let [errorMsg1, setErrorMsg1] = useState({});
    function validateOnboard() {
        const phoneRegex = /^[0]?[6789]\d{9}$/;
        let errror = {};

        if (technicianUser.Mobile_Number != null) {
            if ((technicianUser.Mobile_Number != "" && technicianUser.Mobile_Number.length) > 10 || (technicianUser.Mobile_Number != "" && technicianUser.Mobile_Number.length < 10)) {
                errror.Mobile_Number = "Enter valid mobile number";//Select Acoount"
            }
            if (technicianUser.Mobile_Number != null && isNaN(technicianUser.Mobile_Number)) {
                errror.Mobile_Number = "Mobile number must be in digit";
            }
            else if (technicianUser.Mobile_Number.match(phoneRegex)) {
            }
            else {
                errror.Mobile_Number = "Enter valid mobile number";
            }
        }
        setErrorMsg1(errror);
        if (Object.keys(errror).length == 0) {
            technicianUserOnboard();
        }
    }
    function reset() {
        setTechnicianUser({
            businessFunction: "",
            Area: "",
            Branch: "",
            firstName: "",
            lastName: "",
            emailID: "",
            Mobile_Number: "",
            areaID: "",
            branchID: "",
            personaID: ""
        })
    }

    return (
        <div className='main-container'>
            <Alert obj={alert} />
            <SessionFun show={sessOut}></SessionFun>
            <h4 className='main-heading'>Technician Master</h4>
            <p className='short-link'><Link to='/'>Home&nbsp;
                <i className='fa fa-angle-right'></i></Link>&nbsp;Technician Master
            </p>
            <div className="row card-box-block mt-3">
                <div className="col-sm-12 mb-3">
                    <small className='red'>* For adding new technicians please go to <b>Godrej User List</b></small>
                </div>
                <div className="col-sm-12">
                    <div className="row">
                        {/* <Form onSubmit={submit}> */}
                        <div className="col-sm-4 left-col">
                            <Form.Group className="mb-3" >
                                <Form.Label>Area<span style={{ color: "red" }}>*</span></Form.Label>
                                <Form.Select className="textbox-back" name='area'
                                    onChange={getData} value={areaID}>
                                    <option value="">Select Area</option>
                                    {
                                        area.map((item, index) =>
                                            <option key={index} value={item.areaID}>{item.areaName}</option>
                                        )
                                    }

                                </Form.Select>
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>Branch<span style={{ color: "red" }}>*</span></Form.Label>
                                <Form.Select className="textbox-back" name='branch'
                                    onChange={getData} >
                                    <option value="">Select Branch</option>
                                    {
                                        branch.map((item, index) =>
                                            <option key={index} value={item.branchID}>{item.branchName}</option>
                                        )
                                    }
                                </Form.Select>

                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>User Name<span style={{ color: "red" }}>*</span></Form.Label>
                                <Form.Select className="textbox-back" name='userName'
                                    onChange={getData}>
                                    <option value="">Select User Name</option>
                                    {
                                        user.map((item, index) =>
                                            <option key={index} value={item.userID}>{item.firstName} {item.lastName}</option>
                                        )
                                    }

                                </Form.Select>
                            </Form.Group>
                        </div>


                        {/* </Form> */}
                    </div>

                </div>
            </div>
            {
                technicianUser.isOnboarded ?
                    <div className={istechnique ? "mt-3 card-box-block" : "d-none"}>

                        <div className="col-sm-12">
                            <div className="row">
                                {/* <Form onSubmit={submit}> */}
                                <div className="col-sm-4 left-col">
                                    <Form.Group className="mb-4" >
                                        <Form.Label>Business Function</Form.Label>
                                        <Form.Control type="text" className="textbox-back" name='businessFunction' placeholder="Enter Business Function" value={technicianUser.businessFunction}
                                            readOnly />
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-4" >
                                        <Form.Label>Area<span style={{ color: "red" }}>*</span></Form.Label>

                                        <Form.Select className="textbox-back" name='areaID'
                                            onChange={getTechnicianMasterData} value={technicianUser.areaID}>
                                            <option value="">Select Area</option>
                                            {
                                                area.map((item, index) =>
                                                    <option key={index} value={item.areaID}>{item.areaName}</option>
                                                )
                                            }
                                        </Form.Select>
                                        <small className='red'>{errorMsg.areaID}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-4" >
                                        <Form.Label>Branch<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Select className="textbox-back" name='branchID'
                                            onChange={getTechnicianMasterData} value={technicianUser.branchID}>
                                            <option value="">Select Branch</option>
                                            {
                                                branch1.map((item, index) =>

                                                    <option key={index} value={item.branchID}>{item.branchName}</option>
                                                )
                                            }
                                        </Form.Select>
                                        <small className='red'>{errorMsg.branchID}</small>
                                    </Form.Group>
                                </div>


                                {/* </Form> */}
                            </div>

                        </div>
                        <div className="col-sm-12">
                            <div className="row">
                                {/* <Form onSubmit={submit}> */}
                                <div className="col-sm-4 left-col">
                                    <Form.Group className="mb-4" >
                                        <Form.Label>First Name<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control type="text" className="textbox-back" name='firstName' placeholder="Enter First Name" value={technicianUser.firstName}
                                            onChange={getTechnicianMasterData} />
                                        <small className='red'>{errorMsg.firstName}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-4" >
                                        <Form.Label>Last Name<span style={{ color: "red" }}>*</span></Form.Label>
                                        <Form.Control type="text" className="textbox-back" name='lastName' placeholder="Enter Last Name" value={technicianUser.lastName}
                                            onChange={getTechnicianMasterData} />
                                        <small className='red'>{errorMsg.lastName}</small>

                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-4" >
                                        <Form.Label>Persona<span style={{ color: "red" }}>*</span></Form.Label>
                                        {/* <Form.Control type="text" className="textbox-back" name='personaName' placeholder="Enter Persona" value={technicianUser.personaName}
                                            onChange={getTechnicianMasterData} /> */}
                                        <Form.Select className="textbox-back" name='personaID'
                                            value={technicianUser.personaID} onChange={getTechnicianMasterData}>
                                            <option value="">Select Persona</option>
                                            {
                                                persona.map((item, index) =>
                                                    <option key={index} value={item.personaID}>{item.personaName}</option>
                                                )
                                            }
                                        </Form.Select>
                                        <small className='red'>{errorMsg.personaID}</small>
                                    </Form.Group>
                                </div>


                                {/* </Form> */}
                            </div>

                        </div>
                        <div className="col-sm-12">
                            <div className="row">
                                {/* <Form onSubmit={submit}> */}
                                <div className="col-sm-4 left-col">
                                    <Form.Group className="mb-4" >
                                        <Form.Label>Email ID</Form.Label>
                                        <Form.Control type="text" className="textbox-back" name='emailID' placeholder="Enter Email ID" value={technicianUser.emailID}
                                            readOnly />
                                        <small className='red'>{errorMsg.emailID}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-4" >
                                        <Form.Label>Mobile No.</Form.Label>
                                        <Form.Control type="text" className="textbox-back" name='Mobile_Number' placeholder="Enter Mobile No." value={technicianUser.Mobile_Number}
                                            onChange={getTechnicianMasterData} maxLength="10" />
                                        <small className='red'>{errorMsg.Mobile_Number}</small>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-5" >
                                        <Form.Label> Status<span style={{ color: "red" }}>*</span></Form.Label>
                                        {/* {
                                            technicianUser.isActive ? */}

                                        {/* // <Form.Control type="text" className="textbox-back" placeholder="Status" value="Active" /> */}
                                        <Form.Select className="textbox-back" name='isActive' value={technicianUser.isActive} onChange={getTechnicianMasterData}>
                                            <option value="true" >Active</option>
                                            <option value="false">Inactive</option>
                                        </Form.Select>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                </div> <div className="col-sm-4">
                                </div>
                                <div className="col-sm-4">

                                    <button className="add-btn btn-save float-end" onClick={validate} >
                                        Update
                                    </button>
                                </div>

                                {/* </Form> */}
                            </div>

                        </div>
                    </div>
                    :
                    <div className={istechnique ? "mt-3 card-box-block" : "d-none"}>

                        <div className="col-sm-12">
                            <div className="row">
                                {/* <Form onSubmit={submit}> */}
                                <div className="col-sm-4 left-col">
                                    <Form.Group className="mb-4" >
                                        <Form.Label>Business Function</Form.Label>
                                        <Form.Control type="text" className="textbox-back" value={technicianUser.businessFunction} readOnly />
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-4" >
                                        <Form.Label>Area</Form.Label>
                                        <Form.Control type="text" className="textbox-back" value={technicianUser.areaName} readOnly />
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-4" >
                                        <Form.Label>Branch</Form.Label>
                                        <Form.Control type="text" className="textbox-back" value={technicianUser.Branch} readOnly />

                                    </Form.Group>
                                </div>


                                {/* </Form> */}
                            </div>

                        </div>
                        <div className="col-sm-12">
                            <div className="row">
                                {/* <Form onSubmit={submit}> */}
                                <div className="col-sm-4 left-col">
                                    <Form.Group className="mb-4" >
                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control type="text" className="textbox-back" value={technicianUser.firstName} readOnly />
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-4" >
                                        <Form.Label>Last Name</Form.Label>
                                        <Form.Control type="text" className="textbox-back" value={technicianUser.lastName} readOnly />

                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-4" >
                                        <Form.Label>Persona</Form.Label>
                                        <Form.Control type="text" className="textbox-back" value={technicianUser.personaName} readOnly />

                                    </Form.Group>
                                </div>


                                {/* </Form> */}
                            </div>

                        </div>
                        <div className="col-sm-12">
                            <div className="row">
                                {/* <Form onSubmit={submit}> */}
                                <div className="col-sm-4 left-col">
                                    <Form.Group className="mb-4" >
                                        <Form.Label>Email ID</Form.Label>
                                        <Form.Control type="text" className="textbox-back" value={technicianUser.emailID} readOnly />
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-4" >
                                        <Form.Label>Mobile No.</Form.Label>
                                        <Form.Control type="text" className="textbox-back" name='Mobile_Number' value={technicianUser.Mobile_Number}
                                            onChange={getTechnicianMasterData} />
                                        <small className='red'>{errorMsg1.Mobile_Number}</small>

                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                    <Form.Group className="mb-5" >
                                        <Form.Label> Status</Form.Label>
                                        <Form.Select as="select" aria-label="Default select example" name='isActive' value={technicianUser.isActive} onChange={getTechnicianMasterData}>
                                            <option value="true" >Active</option>
                                            <option value="false">Inactive</option>
                                        </Form.Select>
                                    </Form.Group>
                                </div>
                                <div className="col-sm-4">
                                </div> <div className="col-sm-4">
                                </div>
                                <div className="col-sm-4">

                                    <button className="add-btn btn-save float-end" onClick={validateOnboard}>
                                        Onboard
                                    </button>
                                </div>

                                {/* </Form> */}
                            </div>

                        </div>
                    </div>
            }


        </div>
    )
}

export default TechnicianMaster